import React from "react";
import { useFormikContext, Field, FormikValues } from "formik";

import { bemClassName } from "../../utils/bemClassName";
import { joinClassNames } from "../../utils/joinClassNames";
import { useSearchFormContext } from "../../context/SearchFormContext";

import styles from "./QueryField.module.css";

export const QueryField = () => {
    const { values } = useFormikContext() as FormikValues;
    const { query } = useSearchFormContext();
    const { id, label, placeholder, type } = query;

    type OptionalFieldProps = {
        [key: string]: boolean | string | undefined;
        disabled?: boolean;
        id?: string;
        placeholder?: string;
    };
    const optionalPropDefs: OptionalFieldProps = {
        id,
        placeholder,
    };
    const optionalProps: OptionalFieldProps = {};
    Object.keys(optionalPropDefs).forEach((prop) => {
        const propValue = optionalPropDefs[prop];
        if (propValue) {
            optionalProps[prop] = propValue;
        }
    });

    return (
        <React.Fragment>
            {" "}
            <div
                className={joinClassNames(["input-group", "twitter-typeahead"])}
            >
                <label className="sr-only" htmlFor={id}>
                    Search by keywords
                </label>
                <Field
                    type={type}
                    name="query"
                    aria-label={label}
                    value={values.query}
                    {...optionalProps}
                    className={joinClassNames([
                        "form-control",
                        "input-lg",
                        "query",
                        bemClassName("planning-search-field", "query"),
                    ])}
                />
            </div>
            <button
                type="submit"
                className={joinClassNames([
                    bemClassName("find-a-panel", "search-btn"),
                    bemClassName("planning-search-form", "submit"),
                    styles.submitButton,
                ])}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    id="icon_search"
                    className={bemClassName(
                        "planning-search-form",
                        "submit-icon"
                    )}
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.99 9.243c1.597-2.45 1.224-5.82-1.133-7.833C7.59-.526 4.137-.46 1.94 1.557a6 6 0 00-.19 8.653c2.043 2.045 5.205 2.293 7.527.757.031-.02.102-.083.198-.173l4.343 4.195a.941.941 0 101.308-1.354l-4.324-4.176c.098-.106.166-.184.188-.216zm-8.023-.25a4.274 4.274 0 010-6.035 4.266 4.266 0 016.03 0 4.274 4.274 0 010 6.034 4.266 4.266 0 01-6.03 0z"
                        fill="inherit"
                    ></path>
                </svg>
                <span className="sr-only">Search</span>
            </button>
        </React.Fragment>
    );
};

export default QueryField;
